<template>
    <el-dialog title="Filters"
               width="1000px"
               :visible.sync="showForm"
               :close-on-click-modal="false">

        <el-tabs type="card">

            <el-tab-pane label="Employer">
                <filter-text id="employer_id" name="Employer ID" type="number" :data="filter"></filter-text>
                <filter-text id="employer" name="Employer contains" type="text" :data="filter"></filter-text>
                <filter-select id="agency" name="Agency" :dropdown="dropdowns.agency" :data="filter"></filter-select>
                <filter-text id="campaign" name="Campaign contains" type="text" :data="filter"></filter-text>
                <filter-boolean id="has_3rd_party_lp_jobs" name="Campaign has 3rd party LP jobs" :data="filter"></filter-boolean>
                <filter-select id="account_manager" name="Account Manager" :dropdown="dropdowns.account_manager" :data="filter"></filter-select>
                <filter-select id="salesman" name="Sales Rep" :dropdown="dropdowns.sales_rep" :data="filter"></filter-select>
            </el-tab-pane>

            <el-tab-pane label="Billing Setup">
                <filter-number-between id="billable" name="Billable between" :data="filter"></filter-number-between>
                <filter-number-between id="budget" name="Budget between" :data="filter"></filter-number-between>
                <filter-select id="billing_type" name="Subscription Type" :dropdown="dropdowns.billing_type" :data="filter"></filter-select>
                <filter-select id="billing_status" name="Status" :dropdown="dropdowns.status" :data="filter"></filter-select>
                <filter-text id="io_number" name="IO Number" type="number" :data="filter"></filter-text>
            </el-tab-pane>

            <el-tab-pane label="MC Setup">
                <filter-boolean id="mc_enabled" name="Multi-Carrier" :data="filter"></filter-boolean>
                <filter-number-between id="mc_budget" name="Budget between" :data="filter"></filter-number-between>
                <filter-number-between id="mc_app_goal" name="Lead Goal between" :data="filter"></filter-number-between>
                <filter-boolean id="mc_autopacing" name="Automatic daily pacing" :data="filter"></filter-boolean>
                <filter-boolean id="mc_promoted" name="Promoted" :data="filter"></filter-boolean>
                <filter-boolean id="mc_owner_operator" name="Owner Operator MC" :data="filter"></filter-boolean>
                <filter-boolean id="mc_match_equipment_interest" name="MC Match Equipment Interest" :data="filter"></filter-boolean>
                <filter-boolean id="mc_match_equipment_experience" name="MC Match Equipment XP" :data="filter"></filter-boolean>
                <filter-boolean id="mc_match_route" name="MC Match Route" :data="filter"></filter-boolean>
                <filter-boolean id="mc_match_teams" name="MC Match Teams" :data="filter"></filter-boolean>
                <filter-boolean id="mc_match_twic" name="MC Match TWIC" :data="filter"></filter-boolean>
                <filter-boolean id="mc_filter_timeandday" name="MC Time and Day Filter" :data="filter"></filter-boolean>
            </el-tab-pane>

            <el-tab-pane label="Direct Setup">
                <filter-boolean id="direct_enabled" name="Direct Leads" :data="filter"></filter-boolean>
                <filter-number-between id="direct_budget" name="Budget between" :data="filter"></filter-number-between>
                <filter-number-between id="direct_app_goal" name="Lead Goal between" :data="filter"></filter-number-between>
                <filter-boolean id="direct_autopacing" name="Automatic weekly pacing" :data="filter"></filter-boolean>
                <filter-boolean id="direct_jobboard" name="Job Board Enabled" :data="filter"></filter-boolean>
                <filter-boolean id="direct_jobboard_promoted" name="Job Board Promoted" :data="filter"></filter-boolean>
                <filter-boolean id="calls_enabled" name="Twilio Tracked Calls" :data="filter"></filter-boolean>
            </el-tab-pane>

            <el-tab-pane label="Pacing">
                <filter-pacing id="apps_pacing" name="Pacing (by leads)" :data="filter"></filter-pacing>
                <filter-pacing id="budget_pacing" name="Pacing (by budget)" :data="filter"></filter-pacing>
                <filter-number-between id="apps" name="Leads between" :data="filter"></filter-number-between>
                <filter-number-between id="spend" name="Spend between" :data="filter"></filter-number-between>
                <filter-number-between id="apps_needed" name="Leads needed between" :data="filter"></filter-number-between>
            </el-tab-pane>

            <el-tab-pane label="MC Pacing">
                <filter-pacing id="mc_apps_pacing" name="MC Pacing (by leads)" :data="filter"></filter-pacing>
                <filter-pacing id="mc_budget_pacing" name="MC Pacing (by budget)" :data="filter"></filter-pacing>
                <filter-number-between id="mc_apps" name="MC Leads between" :data="filter"></filter-number-between>
                <filter-number-between id="mc_spend" name="MC Spend between" :data="filter"></filter-number-between>
                <filter-number-between id="mc_apps_needed" name="MC Leads needed between" :data="filter"></filter-number-between>
                <filter-boolean id="mc_over_daily_app_goal" name="MC over daily lead goal" :data="filter" yes-label="Yes" no-label="No"></filter-boolean>
            </el-tab-pane>

            <el-tab-pane label="Direct Pacing">
                <filter-pacing id="direct_apps_pacing" name="Direct Pacing (by leads)" :data="filter"></filter-pacing>
                <filter-pacing id="direct_budget_pacing" name="Direct Pacing (by budget)" :data="filter"></filter-pacing>
                <filter-number-between id="direct_apps" name="Direct Leads between" :data="filter"></filter-number-between>
                <filter-number-between id="direct_spend" name="Direct Spend between" :data="filter"></filter-number-between>
                <filter-number-between id="direct_apps_needed" name="Direct Leads needed between" :data="filter"></filter-number-between>
            </el-tab-pane>

            <el-tab-pane label="DEJA Fulfillment">
                <filter-boolean id="fulfillment_exists" name="Fulfillment" :data="filter" yes-label="Requested" no-label="Not requested"></filter-boolean>
                <filter-number-between id="fulfillment_apps_ordered" name="FF Leads ordered between" :data="filter"></filter-number-between>
                <filter-number-between id="fulfillment_apps_delivered" name="FF Leads delivered between" :data="filter"></filter-number-between>
                <filter-number-between id="fulfillment_apps_needed" name="FF Leads needed between" :data="filter"></filter-number-between>
                <filter-select id="fulfillment_order_type" name="FF Order Type" :dropdown="dropdowns.fulfillment_order_type" :data="filter"></filter-select>
                <filter-select id="fulfillment_status" name="FF Status" :dropdown="dropdowns.fulfillment_status" :data="filter"></filter-select>
            </el-tab-pane>
        </el-tabs>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save">Filter</el-button>
        </span>
    </el-dialog>
</template>

<script>
import FilterPacing from "./filter-pacing";

export default {
        components: {FilterPacing},
        props: [
            'show',
            'dropdowns',
            'filter'
        ],
        data() {
            return {
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
                this.$emit('filter');
                this.showForm = false;
            }
        }
    }
</script>

<style>
    .filter-entry {
        margin-top: 20px;
        display: flex;
        align-items: center;
    }
    .filter-text {
        width: 300px;
        margin: 0 15px;
    }
    .filter-number {
        width: 160px;
        margin: 0 15px;
    }
    .filter-select {
        width: 500px;
        margin: 0 15px;
    }

    .filter-label {
        width: 250px;
        text-align: right;
    }
</style>
